type ErrorWithMessage = {
  message?: string;
  detail?: string;
};

/**
 * Attempts to extract and return "description" from the provided @param err.
 * If a description can be found it is returned
 * otherwise the default will be returned.
 */
export const errorMessageOrDefault = (
  err: unknown,
  fallback: string | null = "There was an unknown error.",
): string | null => {
  if (!err) {
    return null;
  }

  const errMightHaveMessage = err as ErrorWithMessage;

  return errMightHaveMessage.detail ?? errMightHaveMessage.message ?? fallback;
};
